// extracted by mini-css-extract-plugin
export default {"dark":"_6Er8C","light":"YDpZb"};